module.exports = __webpack_public_path__ + "static/media/default.3fd66b69.svg";